import CaseStudy from '../CaseStudy/CaseStudy';
import Insight from '../Insight/Insight';
import POVBlock from '../POVBlock/POVBlock';

class ServiceLine {
  constructor(contentfulNode) {
    this.title = contentfulNode?.title;
    this.descriptionRichJSON = contentfulNode?.subheading;
    this.slug = contentfulNode?.slug ? contentfulNode?.slug : contentfulNode?.referenceLink;
    this.serviceSlug = contentfulNode?.service ? contentfulNode?.service[0].slug : null;
  }
}

class Partnership {
  constructor(contentfulNode, globalPartnershipReference) {
    this.serviceOfferingsLabel =
      contentfulNode?.serviceOfferingsLabel || globalPartnershipReference?.serviceOfferingsLabel;
    this.serviceLines = contentfulNode?.serviceOfferings
      ? contentfulNode?.serviceOfferings.map(serviceLine => new ServiceLine(serviceLine))
      : globalPartnershipReference?.serviceOfferings
      ? globalPartnershipReference?.serviceOfferings.map(serviceLine => new ServiceLine(serviceLine))
      : null;
    this.serviceOfferingsTitle =
      contentfulNode?.serviceOfferingsTitle || globalPartnershipReference?.serviceOfferingsTitle;
    this.serviceOfferingsRichText =
      contentfulNode?.serviceOfferingsRichText || globalPartnershipReference?.serviceOfferingsRichText;
    this.logo = {
      fluid: contentfulNode?.logo?.gatsbyImageData || globalPartnershipReference?.logo?.gatsbyImageData
    };
    this.slug = contentfulNode?.slug || globalPartnershipReference?.slug;
    this.localizationSlug = contentfulNode?.localizationSlug || globalPartnershipReference?.localizationSlug;
    this.snippet = contentfulNode?.snippet || globalPartnershipReference?.snippet;
    this.title = contentfulNode?.title || globalPartnershipReference?.title;
    this.excludePartnershipTitle =
      contentfulNode?.excludePartnershipTitle || globalPartnershipReference?.excludePartnershipTitle;
    this.excludePartnershipsUrl =
      contentfulNode?.excludePartnershipsUrl || globalPartnershipReference?.excludePartnershipsUrl;
    this.relatedCaseStudies = contentfulNode?.relatedCaseStudies
      ? contentfulNode?.relatedCaseStudies.map(caseStudy => new CaseStudy(caseStudy))
      : globalPartnershipReference?.relatedCaseStudies
      ? globalPartnershipReference?.relatedCaseStudies.map(caseStudy => new CaseStudy(caseStudy))
      : null;
    this.relatedInsightsLabel =
      contentfulNode?.relatedInsightsLabel || globalPartnershipReference?.relatedInsightsLabel;
    this.relatedInsightsTitle =
      contentfulNode?.relatedInsightsTitle || globalPartnershipReference?.relatedInsightsTitle;
    this.relatedInsights = contentfulNode?.relatedInsights
      ? contentfulNode?.relatedInsights.map(insight => new Insight(insight))
      : globalPartnershipReference?.relatedInsights
      ? globalPartnershipReference?.relatedInsights.map(insight => new Insight(insight))
      : null;
    this.pointOfView = contentfulNode?.pointOfView
      ? new POVBlock(contentfulNode?.pointOfView)
      : globalPartnershipReference?.pointOfView
      ? new POVBlock(globalPartnershipReference?.pointOfView)
      : null;
    this.howWeCanHelp = contentfulNode?.howWeCanHelp || globalPartnershipReference?.howWeCanHelp;
    this.partnershipOffering = contentfulNode?.partnershipOffering || globalPartnershipReference?.partnershipOffering;
    this.partnershipOfferingsLabel =
      contentfulNode?.partnershipOfferingsLabel || globalPartnershipReference?.partnershipOfferingsLabel;
    this.partnershipOfferingsTitle =
      contentfulNode?.partnershipOfferingsTitle || globalPartnershipReference?.partnershipOfferingsTitle;
    this.partnershipOfferingsRichText =
      contentfulNode?.partnershipOfferingsRichText || globalPartnershipReference?.partnershipOfferingsRichText;
    this.partnershipOfferings = contentfulNode?.partnershipOfferingsReferences
      ? contentfulNode?.partnershipOfferingsReferences.map(offering => new Partnership(offering))
      : globalPartnershipReference?.partnershipOfferingsReferences
      ? globalPartnershipReference?.partnershipOfferingsReferences.map(offering => new Partnership(offering))
      : null;
    this.solutionDetail = contentfulNode?.solutionDetail
      ? new POVBlock(contentfulNode?.solutionDetail)
      : globalPartnershipReference?.solutionDetail
      ? new POVBlock(globalPartnershipReference?.solutionDetail)
      : null;
    this.certificationsLabel = contentfulNode?.certificationsLabel || globalPartnershipReference?.certificationsLabel;
    this.certificationsTitle = contentfulNode?.certificationsTitle || globalPartnershipReference?.certificationsTitle;
    this.certificationsRichText =
      contentfulNode?.certificationsRichText || globalPartnershipReference?.certificationsRichText;
    this.certificationsImageCarousel =
      contentfulNode?.certificationsImageCarousel || globalPartnershipReference?.certificationsImageCarousel;
    this.expertsLabel = contentfulNode?.expertsLabel || globalPartnershipReference?.expertsLabel;
    this.expertsTitle = contentfulNode?.expertsTitle || globalPartnershipReference?.expertsTitle;
    this.expertsRichText = contentfulNode?.expertsRichText || globalPartnershipReference?.expertsRichText;
    this.featuredContent = contentfulNode?.featuredContent || globalPartnershipReference?.featuredContent;
    this.capabilitiesOverviewBlock = contentfulNode?.capabilitiesOverviewBlock
      ? new POVBlock(contentfulNode.capabilitiesOverviewBlock)
      : globalPartnershipReference?.capabilitiesOverviewBlock
      ? new POVBlock(globalPartnershipReference.capabilitiesOverviewBlock)
      : null;
    this.partnershipCategory = contentfulNode?.partnershipCategory || globalPartnershipReference?.partnershipCategory;
    this.externalPartnershipLink =
      contentfulNode?.externalPartnershipLink || globalPartnershipReference?.externalPartnershipLink;
  }
}

export default Partnership;
